export default function asPercent(x: number) {
    return `${x.toFixed(2)}%`
}

export function roundNumber(num: number, decimalPlaces: number) {
    const rounded = num.toFixed(decimalPlaces)
    return parseFloat(rounded) // eliminate insignificant zero from rounding
}

// Most quantity of items -> 5 precision
export function roundQuantityNumber(num?: number | null) {
    return roundNumber(num ?? 0, 5)
}
